// extracted by mini-css-extract-plugin
module.exports = {"ServicePanel":"ServicePanel--3xQYB","serviceThree":"serviceThree--2uCWk","tipTitle":"tipTitle--1hWwc","tipCon":"tipCon--23LBj","serviceFour":"serviceFour--1V3I_"};
    if(module.hot) {
      // 1675232528974
      var cssReload = require("/workspace/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  